//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Input from 'ui-kit/src/components/form/Input';

export default {
    extends: Input,

    props: {
        collName: String,
        refName: String,
    },

    data() {
        return {
            refFieldsContainer: {},
        };
    },

    computed: {
        refDef() {
            return $.getExpandedRefDef(this.collName, this.refName);
        },
    },

    methods: {
        onClick() {
            this.$emit('add', this.model, this.refFieldsContainer);

            this.refFieldsContainer = {};
        },
    },
};
